module.exports = __webpack_public_path__ + "img/menu_visa.42b0b7d3.png";